import React from "react";

import styles from "./Table.module.css";

type ChildrenProps = {
  children?: React.ReactNode;
};

export function Table({ children }: ChildrenProps) {
  return <table className={styles.table}>{children}</table>;
}

export function TableHead({ children }: ChildrenProps) {
  return <thead className={styles.listHead}>{children}</thead>;
}

export function TableHeaderRow({ children }: ChildrenProps) {
  return <tr className={styles.tableHead}>{children}</tr>;
}

export type TableHeaderCellProps = {
  width?: number;
} & ChildrenProps;
export function TableHeaderCell({ width, children }: TableHeaderCellProps) {
  return (
    <th scope="col" className={styles.columnTitle} style={{ width }}>
      {children}
    </th>
  );
}

export function TableBody({ children }: ChildrenProps) {
  return <tbody>{children}</tbody>;
}

export function TableRow({ children }: ChildrenProps) {
  return <tr className={styles.tableRow}>{children}</tr>;
}

export function TableCell({ children }: ChildrenProps) {
  return (
    <td scope="row" className={styles.tableCell}>
      {children}
    </td>
  );
}
